<div class="table">
  <table fixedcols="[0]">
    <tr>
      <th>{{'Parameter'|translate }}</th>
      <th>{{'Value'|translate }}</th>
    </tr>
    <tr>
      <td>{{'Server status'|translate }}</td>
      <td>{{'Started'|translate }}</td>
    </tr>
    <tr>
      <td>{{'MySQL server'|translate }}</td>
      <td>{{'Connected'|translate }}</td>
    </tr>
    <tr>
      <td>{{'Devices online'|translate }}</td>
      <td>{{'567'|translate }}</td>
    </tr>
    <tr>
      <td>{{'Memory used'|translate }}</td>
      <td>{{'65 Mb'|translate }}</td>
    </tr>
    <tr>
      <td>{{'CPU load'|translate }}</td>
      <td>{{'13 %'|translate }}</td>
    </tr>
    <tr>
      <td>{{'Points queue'|translate }}</td>
      <td>{{'65'|translate }}</td>
    </tr>
  </table>
</div>
